export function insertThrobber(container) {
    const throbber = '<div class="preloader-dc-wrapper"><div class="preloader-wrapper">' +
        '<div class="preloader-spinner"></div>' +
        '</div></div>';
    container.insertAdjacentHTML('afterbegin', throbber);
}

export function removeThrobber() {
    const throbber = document.querySelector('.preloader-dc-wrapper');
    if (throbber) {
        throbber.remove();
    }
}
export function validateForm(form) {
    const invalidInputs = form.querySelectorAll('input:invalid');
    if (invalidInputs.length !== 0) {
        invalidInputs.forEach((invalidInput): void => {
            if (invalidInput.type === 'email' && invalidInput.value.length > 0) {
                invalidInput.parentElement.querySelector('.js-error-empty-filed').classList.add('hidden');
                invalidInput.parentElement.querySelector('.js-error-invalid-email').classList.remove('hidden');
            } else {
                invalidInput.parentElement.querySelector('.js-error-empty-filed').classList.remove('hidden');
            }
        });
        const validInputs = form.querySelectorAll('input:valid');
        validInputs.forEach((validInput): void => {
            const errorDiv = validInput.parentElement.querySelectorAll('.js-error-message');
            if (errorDiv) {
                errorDiv.forEach(input => {
                    input.classList.add('hidden');
                });
            }
        });
        return false;
    } else {
        return true;
    }
}

export function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : '';
}

export function setCookie(name, value) {
    document.cookie = name + '=' + value +
        ('; Path=/');
}

//add or remove item from cart
export function addRemoveCart(el, cookieName) {
    const id = el.dataset.source;
    let cookie = getCookie(cookieName);
    const cartList = document.querySelector('.schl-cart-items') as HTMLDivElement;
    if (cartList) {
        if (el.classList.contains('add')) {
            if (cookie.indexOf('|' + id) === -1) {
                cookie = cookie + '|' + id;
            }

            el.classList.remove('add');
            el.classList.add('remove');
            el.firstElementChild.className = 'icon-circle-minus';

            //check if we load all items from cookie
            let cartItems = cookie.split('|');
            //TODO somewhere is added an empty cookie
            if ((cartItems.length - 2) !== cartList.childElementCount) {
                // Add item to cart block.
                const itemWrapper = el.closest('.view-mode-media-list');
                const itemImg = itemWrapper.querySelector('img').getAttribute('src');
                const itemName = itemWrapper.querySelector('.dc-product-item__name').textContent;
                const itemSizeExt = itemWrapper.querySelector('.dc-product-item__text').textContent;
                const data = '<li data-id="' + id + '"><div class="cart-item">' +
                    '<div class="cart-item__image">' +
                    '<img class="basket-image" src="' + itemImg + '"  loading="lazy" />' +
                    '</div>' +
                    '<div class="cart-item__content">' +
                    '<div class="cart-item__title">' + itemName + '</div>' +
                    '<div class="cart-item__text">' + itemSizeExt + '</div>' +
                    '</div>' +
                    '<div class="cart-item__remove">' +
                    '<a href="#" data-source="' + id + '" class="selected-item-remove">' +
                    '<i class="icon-circle-minus"></i>' +
                    '</a>' +
                    '</div>' +
                    '</div></li>';
                cartList.insertAdjacentHTML('beforeend', data);
            }
        } else {
            cookie = cookie.replace('|' + id, '');
            el.classList.remove('remove');
            el.classList.add('add');
            el.firstElementChild.className = 'icon-plus-circle';
            //remove item from cart
            const itemRemove =  cartList.querySelector('[data-source="' + id + '"]');
            if (itemRemove) {
              itemRemove.remove();
            }
        }
        setCookie(cookieName, cookie);
        updateBasketLinks();
    }
}

// disable/enable basket links
export function updateBasketLinks() {
    let cookie = getCookie('schl_mc_cart');
    const cartLink = document.querySelector('.cart-link');
    const cartLinkCounter = document.querySelector('.cart-link__counter');

    if (cookie) {
        if (cartLink) {
            cartLink.classList.remove('disabled');
            let cartItems = cookie.split('|');

            //add cart items count
            if (cartLinkCounter) {
                cartLinkCounter.classList.remove('hidden');
                cartLinkCounter.innerHTML = (cartItems.length - 1).toFixed();
            }
            removeCartClick();
        }
    } else {
        //diable basket link
        const cart = document.querySelector('.js-schl-mc-cart');
        if (cart) {
            cart.classList.add('hidden');
        }
        if (cartLink) {
            cartLink.classList.add('disabled');
        }
        //hide basket
        if (cartLinkCounter) {
            cartLinkCounter.classList.add('hidden');
            cartLinkCounter.innerHTML = '0';
        }
    }
}

//remove item from cart
export function removeCartClick() {
    const cartLink = document.querySelector('.cart-link');
    const cartItems = document.querySelector('.schl-cart-items');

    if (cartLink) {
        if (cartItems) {
            let link = cartItems.querySelectorAll('.cart-item-remove');
            link.forEach(el => {
                el.addEventListener('click', e => {
                    if (e.currentTarget) {
                        if (e.currentTarget instanceof HTMLElement) {
                            let id = e.currentTarget.dataset.source;
                            let cookie = getCookie('schl_mc_cart');
                            cookie = cookie.replace('|' + id, '');
                            let element = document.querySelector('.media-cart[data-source="' + id + '"]');
                            if (element) {
                                element.classList.remove('remove');
                                element.classList.add('add');
                                if (element.firstElementChild) {
                                    element.firstElementChild.className = 'icon-plus-circle';
                                }
                            }
                            //remove item from cart
                            const removeItem = cartItems.querySelector('[data-source="' + id + '"]');
                            if (removeItem) {
                                removeItem.remove();
                            }
                            setCookie('schl_mc_cart', cookie);
                            updateBasketLinks();
                        }
                    }
                });
            });
        }
    }
}
// if the cart is empty - disabled & replace icons for added products
export function updateCartLinkStatus() {
    let cookie = getCookie('schl_mc_cart');
    let cartItems = cookie.split('|');
    if (cookie) {
        const cartLink = document.querySelector('.cart-link');
        if (cartLink) {
            cartLink.classList.remove('disabled');
        }
        //add cart items count
        let cartCount = cartItems.length - 1;
        const cartLinkCounter = document.querySelector('.cart-link__counter');
        if (cartLinkCounter) {
            cartLinkCounter.classList.remove('hidden');
            cartLinkCounter.innerHTML = cartCount.toFixed();
        }
    }
    const cartAction = document.querySelectorAll('div.media-cart-actions > a.media-cart');
    if (cartAction) {
        cartAction.forEach(el => {
            if (el instanceof HTMLElement) {
                let id = el.dataset.source;
                if (id) {
                    if (cookie.indexOf(id) !== -1) {
                        el.classList.remove('add');
                        el.classList.add('remove');
                        if (el.firstElementChild) {
                            el.firstElementChild.className = 'icon-circle-minus';
                        }
                    } else {
                        el.classList.remove('remove');
                        el.classList.add('add');
                        if (el.firstElementChild) {
                            el.firstElementChild.className = 'icon-plus-circle';
                        }
                    }
                }
            }
        });
    }
}

export function hideModal(modal) {
    const divs = modal.querySelectorAll('.js-modalContent');
    divs.forEach(el => {
        el.classList.add('hidden');
    });
}
